import e from "../hooks/HookBuilder.js";
import { SystemService as o } from "../services/system.js";
const r = e.noParamsHook(
  ["system-config"],
  o.getEnvironmentConfig,
  {
    errorMessage: "There was an error trying to get the system config"
  }
), s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useConfig: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as system,
  r as useConfig
};
//# sourceMappingURL=system-CLl-pBkf.js.map
